var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatformautomationLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_581_465)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2959 59.9882C22.6781 58.6608 14.3371 50.3198 13.0111 39.7047C12.9071 38.8845 13.5479 38.1567 14.3775 38.1567H19.944C20.6164 38.1567 21.1893 38.6422 21.3023 39.3039C22.3728 45.6437 27.3529 50.6252 33.6968 51.697C34.3584 51.8099 34.8439 52.3829 34.8439 53.0553V58.6218C34.8438 59.4408 34.1338 60.0879 33.2959 59.9882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.944 35.0351H14.3775C13.5474 35.0351 12.9072 34.3068 13.0111 33.4871C14.4689 21.8081 24.448 13.0005 36.2211 13.0005C41.4513 13.0005 46.41 14.7058 50.5615 17.9322C51.2218 18.4473 51.2713 19.4133 50.6906 19.9939L46.7555 23.9304C46.2794 24.4078 45.5317 24.467 44.9829 24.0783C42.3994 22.2371 39.3694 21.2635 36.221 21.2635C28.812 21.2635 22.5368 26.573 21.3022 33.8879C21.1893 34.5495 20.6164 35.0351 19.944 35.0351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9658 58.6231V53.0567C37.9658 52.3842 38.4513 51.8113 39.113 51.6983C46.4278 50.4637 51.7374 44.1885 51.7374 36.7795C51.7374 33.6312 50.7638 30.6011 48.9226 28.0176C48.5326 27.4702 48.5945 26.7197 49.0705 26.245L53.007 22.3099C53.5802 21.7367 54.5491 21.7731 55.0687 22.439C58.2951 26.5907 60.0004 31.5493 60.0004 36.7794C60.0004 48.5525 51.1927 58.5316 39.5137 59.9895C38.6668 60.0905 37.9658 59.4326 37.9658 58.6231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9881 30.9953C30.9881 30.2348 30.3715 29.6182 29.611 29.6182H26.8567C26.0961 29.6182 25.4795 30.2348 25.4795 30.9953V42.0126C25.4795 42.7732 26.0961 43.3898 26.8567 43.3898H29.611C30.3715 43.3898 30.9881 42.7732 30.9881 42.0126V30.9953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2508 42.0125V28.2409C39.2508 27.4804 38.6342 26.8638 37.8737 26.8638H35.1193C34.3588 26.8638 33.7422 27.4804 33.7422 28.2409V42.0125C33.7422 42.7731 34.3588 43.3897 35.1193 43.3897H37.8737C38.6343 43.3897 39.2508 42.7731 39.2508 42.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5135 42.0128V36.5041C47.5135 35.7436 46.8969 35.127 46.1364 35.127H43.382C42.6215 35.127 42.0049 35.7436 42.0049 36.5041V42.0128C42.0049 42.7733 42.6215 43.3899 43.382 43.3899H46.1364C46.897 43.3899 47.5135 42.7733 47.5135 42.0128Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_581_465",
    x1: 4.5,
    y1: 4,
    x2: 70,
    y2: 71.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformautomationLogo1);
export default __webpack_public_path__ + "static/media/platformautomation-logo-1.939b7e94d9ca61e312bf03c1b4a0e9b6.svg";
export { ForwardRef as ReactComponent };